import { useLingui } from "@lingui/react";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useMatches, useParams } from "react-router-dom";

import { Sex } from "../../api";
import { getAge } from "../../utils/utils";
import { AppModel } from "../app-model";

const BASE_TITLE = "Seerlinq CLV";

export const DocumentTitle = observer(function DocumentTitle({
  app,
}: {
  app: AppModel;
}) {
  const { i18n } = useLingui();
  const params = useParams();
  const matches = useMatches();

  const crumbLabels = useMemo(() => {
    return matches
      .filter((match) => (match.handle as any)?.crumb)
      .map((match) => {
        const crumb = (match.handle as any)?.crumb;
        const value = typeof crumb === "function" ? crumb(params) : crumb;
        return typeof value === "string" ? value : i18n._(value);
      });
  }, [matches, params, i18n]);

  const isPatientPage = params.id != null;
  const data = isPatientPage ? app.patient?.data : undefined;
  const pageName = crumbLabels[crumbLabels.length - 1];

  useEffect(() => {
    if (data?.family_name && pageName) {
      const age = data.date_of_birth ? getAge(data.date_of_birth) : "";
      const sex = data.sex === Sex.M || data.sex === Sex.F ? data.sex : "";
      const patientInfo = `${data.family_name}, ${age}${sex}`;
      document.title = `${patientInfo} | ${data.patient_id} | ${pageName} | ${BASE_TITLE}`;
    } else if (pageName) {
      document.title = `${pageName} | ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }
  }, [
    pageName,
    data?.family_name,
    data?.date_of_birth,
    data?.sex,
    data?.patient_id,
  ]);

  return null;
});
